import { gql } from "@apollo/client";

export const GET_PAIN_ASSESSMENTS_BY_IDS_QUERY = gql`
  query PainAssessmentsByIds($ids: [ID!]!) {
    painAssessmentsByIds(ids: $ids) {
      _id
      patient_id
      date
      gender
      allPaths {
        path {
          x
          y
        }
        painLevel
        painType
        strokeWidth
        color
        orientation
      }
      createdAt
      updatedAt
    }
  }
`;
